import { Component } from '@angular/core';
import { FeaturePreviewComponent } from '../feature-preview.component';

@Component({
  selector: 'app-feature-preview-doku',
  templateUrl: './doku.component.html',
})
export class FeaturePreviewDoku extends FeaturePreviewComponent {}
